// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 40px;
    background-color: #f1f3f6;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .header-left {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .header-logo {
    width: 40px;
    height: 40px;
  }
  
  .header-title {
    font-size: 20px;
    font-weight: bold;
    color: #1f2a38;
  }
  
  .nav-menu {
    display: flex;
    gap: 30px;
  }
  
  .nav-menu a {
    font-size: 16px;
    color: #1f2a38;
    text-decoration: none;
    font-weight: 500;
  }
  
  .nav-menu a:hover {
    text-decoration: underline;
  }
  
  .header-right {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  
  .search-icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
  
  .contact-button {
    padding: 10px 20px;
    background-color: #1f2a38;
    color: #fff;
    border: none;
    border-radius: 25px;
    font-size: 14px;
    font-weight: bold;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .contact-button:hover {
    background-color: #14202e;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,wCAAwC;EAC1C;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,wCAAwC;IACxC,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":[".header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px 40px;\n    background-color: #f1f3f6;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  }\n  \n  .header-left {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n  \n  .header-logo {\n    width: 40px;\n    height: 40px;\n  }\n  \n  .header-title {\n    font-size: 20px;\n    font-weight: bold;\n    color: #1f2a38;\n  }\n  \n  .nav-menu {\n    display: flex;\n    gap: 30px;\n  }\n  \n  .nav-menu a {\n    font-size: 16px;\n    color: #1f2a38;\n    text-decoration: none;\n    font-weight: 500;\n  }\n  \n  .nav-menu a:hover {\n    text-decoration: underline;\n  }\n  \n  .header-right {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n  }\n  \n  .search-icon {\n    width: 20px;\n    height: 20px;\n    cursor: pointer;\n  }\n  \n  .contact-button {\n    padding: 10px 20px;\n    background-color: #1f2a38;\n    color: #fff;\n    border: none;\n    border-radius: 25px;\n    font-size: 14px;\n    font-weight: bold;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    cursor: pointer;\n    transition: background-color 0.3s;\n  }\n  \n  .contact-button:hover {\n    background-color: #14202e;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
